import { Component } from "@angular/core";
import { GlobalApp } from "../../tools/global";
import { InteractivesService, SubscriptionService } from "../../api/services";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { DropDownItem, ManagedSubscription } from "../../api/models";

@Component({
  selector: "app-home",
  templateUrl: "./subscription.component.html",
  styleUrls: ["./subscription.component.css"],
})
export class SubscriptionComponent {
  userSubscriptions: ManagedSubscription[];
  expiredSubscriptions: ManagedSubscription[];

  loadingData: boolean = true;

  constructor(
    private app: GlobalApp,
    private subscriptionService: SubscriptionService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.app.getAuthorizationStatus().subscribe((result) => {
      if (!result.isValid) {
        this.app.logOut();
        this.router.navigate(["login"]);
      } else {
        this.loadSubscriptions();
      }
    });
  }

  loadSubscriptions(): void {
    this.loadingData = true;

    this.subscriptionService.subscriptionGetManagedSubscriptions().subscribe(
      (result) => {
        if (result.length > 0) {
          this.userSubscriptions = result.filter(x => !x.isExpired);
          this.expiredSubscriptions = result.filter(x => x.isExpired);
        } else {
        }

        this.loadingData = false;
      },
      (error) => {
        var t = 0;
      }
    );
  }

  loadSubscriptionDetails(subscriptionId: number): boolean {
    var queryStringParams = {
      subscriptionId: subscriptionId,
    };

    this.router.navigate([
      "subscriptionmanagement",
      queryStringParams.subscriptionId,
    ]);

    return false;
  }

  cancelAutoRenew(subscriptionId: number): boolean {
    this.subscriptionService
      .subscriptionCancelAutoRenew(subscriptionId)
      .subscribe((result) => {
        this.loadSubscriptions();
      });
    return false;
  }

  activateAutoRenew(subscriptionId: number): boolean {
    this.subscriptionService
      .subscriptionActivateAutoRenew(subscriptionId)
      .subscribe((result) => {
        this.loadSubscriptions();
      });
    return false;
  }

  updateAutoRenew(subscriptionId: number): boolean {
    this.router.navigate([
      "update-subscription/" + subscriptionId.toString() + "/Update",
    ]);
    return false;
  }

  renewSubscription(subscriptionId: number): boolean {
    this.router.navigate([
      "update-subscription/" + subscriptionId.toString() + "/Renew",
    ]);
    return false;
  }
}
